import { render, staticRenderFns } from "./goverment-registration.vue?vue&type=template&id=7c6e2027&"
import script from "./goverment-registration.vue?vue&type=script&lang=js&"
export * from "./goverment-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports